<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-android-desktop"></i>
        <div class="mg-l-20">
          <h4>{{ $t("mall.帮助中心管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <button
          class="btn btn-success"
          type="button"
          @click="addNew"
          v-if="isSysRights('SupplierMallHelp.addBySupplier')"
        >
          {{ $t("mall.添加内容") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('status')"
        >
          {{ $t("mall.状态：") }}
          <span class="mg-r-10">{{ $t($dict.helpStatus[keyStatus]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
      <div class="clear-key">
        <a
          v-show="keyType"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('type')"
        >
          {{ $t("mall.类型：") }}
          <span class="mg-r-10">{{ $t($dict.helpType[keyType]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyName", "keyStatus", "keyType", "keyClickType"],
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    addNew() {
      this.$emit("addNew");
    },
  },
};
</script>